// src/utils/auth.js
import { appCode, appCallback } from "@/utils/api.js";
import { useUserStore } from "@/store";
import { isApp } from "@/utils/common";
import { Toast, DialogPlugin } from "tdesign-mobile-vue";

// 添加授权锁，防止重复授权
let isAuthenticating = false;

/**
 * 在APP内直接授权（静默授权）
 * @param {Object} options - 配置选项
 * @returns {Promise<string>} - 返回包含 token 的 Promise
 */
export async function appAuth(options = {}) {
  const { showLoading = true } = options;

  if (!isApp()) {
    throw new Error("请在常观APP中使用此功能");
  }

  // 显示加载提示
  if (showLoading) {
    Toast({
      theme: "loading",
      duration: 0,
      preventScrollThrough: true,
    });
  }

  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await appCode();
      cgapp.config({
        client_id: data.client_id,
      });
      if (showLoading) Toast.clear(); // 清除加载提示
      cgapp.ready(() => {
        window.cgapp.login({
          client_id: data.client_id,
          scopes: data.scopes,
          state: data.state,
          redirect_uri: data.redirect_uri,
          success: (res) => {
            console.log(res);
            const code = res.code;
            const state = res.state;

            appCallback({ code, state })
              .then((res2) => {
                if (res2.code == 1) {
                  const token = res2.data.token;
                  useUserStore().setToken(token);
                  resolve(token);
                } else {
                  console.log("callbackError",res2);
                  reject(res2);
                }
              })
              .catch((error) => {
                console.log("callbackError", error);
                reject(error);
              });
          },
          fail: (error) => {
            console.error("登录失败fail:", error);
            reject(error);
          },
        });
      });
    } catch (err) {
      console.log(err);
      if (showLoading) Toast.clear(); // 清除加载提示
      Toast("授权失败");
      reject(err);
    }
  });
}

/**
 * 检查是否需要重新授权
 */
export function checkAuthRequired() {
  const userStore = useUserStore();
  return userStore.isLogin; // 如果已登录但token可能过期，则需要重新授权
}

/**
 * 检查是否正在授权中
 */
export function isAuthInProgress() {
  return isAuthenticating;
}

/**
 * 取消当前授权过程（如果需要）
 */
export function cancelAuth() {
  if (isAuthenticating) {
    isAuthenticating = false;
    Toast.clear();
  }
}
